"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.ErrorText = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1d6gq94-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    background: #fff;\n    min-width: 320px;\n    max-width: 1000px;\n    padding: 40px 20px;\n    border-radius: 8px;\n    flex-direction: column;\n"])));

exports.Container = Container;
var themes = {
  success: _constants.COLORS.lightGreen,
  error: '#EC8F8F',
  "default": _constants.COLORS.black
};

var ErrorText = _styledComponents["default"].p.withConfig({
  displayName: "styled__ErrorText",
  componentId: "sc-1d6gq94-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-weight: 800;\n    ", ";\n    color: ", ";\n    margin: 20px 0 10px;\n    width: 70%;\n\n    @media (max-width: 640px) {\n        max-width: 90%;\n    }\n"])), _constants.FONTS.H3, function (props) {
  return themes[props.theme];
});

exports.ErrorText = ErrorText;

var Text = _styledComponents["default"].p.withConfig({
  displayName: "styled__Text",
  componentId: "sc-1d6gq94-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin: 0;\n    color: ", ";\n    ", ";\n    width: 100%;\n"])), _constants.COLORS.black, _constants.FONTS.M);

exports.Text = Text;